var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43945 7.00039C1.43945 7.00039 3.83945 1.40039 9.43945 1.40039C15.0395 1.40039 17.4395 7.00039 17.4395 7.00039C17.4395 7.00039 15.0395 12.6004 9.43945 12.6004C3.83945 12.6004 1.43945 7.00039 1.43945 7.00039Z",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43945 9.40039C10.7649 9.40039 11.8395 8.32587 11.8395 7.00039C11.8395 5.67491 10.7649 4.60039 9.43945 4.60039C8.11397 4.60039 7.03945 5.67491 7.03945 7.00039C7.03945 8.32587 8.11397 9.40039 9.43945 9.40039Z",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentView);
export default __webpack_public_path__ + "static/media/document-view.b71cf340dabc66b312a9c4fb4929e757.svg";
export { ForwardRef as ReactComponent };